import React, { Children } from 'react';
import { motion } from 'framer-motion';
const CHECKOUT_URL = 'https://l.instagram.com/?u=http%3A%2F%2Fwa.me%2F17868671817%3Futm_source%3Dig%26utm_medium%3Dsocial%26utm_content%3Dlink_in_bio%26fbclid%3DPAZXh0bgNhZW0CMTEAc3J0YwZhcHBfaWQMMjU2MjgxMDQwNTU4AAGnaqJ2Sof8kfKpMO62ETPquQzMk-2f5LDvIZ9MIKBRalOfvG9MYpFuYb5DDDE_aem_l3V7ISs1CoqqMmsUrca1pg&e=AT7ythc19Xwk1ZxDZqn7pj_Ell9adPiCk2-P9fqK616cnbmjzxEBcJ8ATXaG_tA4TMS_dwYUCoaPw3TvwftFSgyJXyIwu7Nn4YUvG2aIPQ';
interface ServicesProps {
  setIsBookingOpen?: (open: boolean) => void;
  onBookClick?: () => void; // Keeping for backwards compatibility if used elsewhere
}
const serviceCategories = [{
  category: 'LIMPIEZAS FACIALES',
  items: [{
    name: 'Limpieza Profunda',
    price: '$130',
    description: 'Protocolo avanzado que elimina impurezas, controla el exceso de grasa, desobstruye los poros y mejora la oxigenación de la piel.'
  }, {
    name: 'Hidrofacial',
    price: '$150',
    description: 'Tratamiento en múltiples pasos que limpia, exfolia, extrae y aporta hidratación profunda con tecnología avanzada. Mejora textura, luminosidad y deja un brillo inmediato sin tiempo de recuperación.'
  }, {
    name: 'Oxymask',
    price: '$150',
    description: 'Terapia oxigenante que estimula la microcirculación, revitaliza la piel y mejora su luminosidad natural.'
  }]
}, {
  category: 'HIDRATACIÓN Y REVITALIZACIÓN',
  items: [{
    name: 'Hyal Complex',
    price: '$140',
    description: 'Hidratación profunda con ácido hialurónico que mejora elasticidad, suavidad y aporta un aspecto saludable.'
  }, {
    name: 'Facial Revitalizador',
    price: '$140',
    description: 'Reenergiza la piel, mejora textura y devuelve vitalidad y luminosidad.'
  }, {
    name: 'Dermaplaning SilkSkin',
    price: '$140',
    description: 'Exfoliación avanzada que elimina células muertas y vello fino para una piel lisa y luminosa.'
  }, {
    name: 'Peeling de Algas',
    price: '$140',
    description: 'Peeling biológico que estimula la regeneración, mejora textura y aporta luminosidad.'
  }]
}, {
  category: 'MICRONEEDLING Y TRATAMIENTOS AVANZADOS',
  items: [{
    name: 'Protocolo Signature BY CINDY SALLOUM: Exosomas + PDRN',
    price: '$270',
    description: 'Tratamiento regenerativo que mejora firmeza, textura, cicatrices, líneas finas y calidad de la piel.'
  }, {
    name: 'Microneedling con PDRN de salmón',
    price: '$250',
    description: 'Estimula la reparación dérmica, hidrata profundamente y mejora elasticidad.'
  }, {
    name: 'Vitamina C con microagujas',
    price: '$150',
    description: 'Ilumina, unifica el tono y estimula la producción de colágeno.'
  }, {
    name: 'FirmSkin reafirmante',
    price: '$150',
    description: 'Mejora firmeza, tonicidad y suaviza líneas finas.'
  }, {
    name: 'Control de manchas ClearTone',
    price: '$150',
    description: 'Tratamiento despigmentante que aclara manchas y mejora la uniformidad del tono.'
  }]
}, {
  category: 'PEELINGS Y DESPIGMENTACIÓN',
  items: [{
    name: 'Peeling iluminador Addictive',
    price: '$150',
    description: 'Renueva la piel, mejora la textura y aporta brillo inmediato.'
  }, {
    name: 'Peeling de hiperpigmentación',
    price: '$160',
    description: 'Especializado en aclarar manchas y mejorar el tono.'
  }]
}, {
  category: 'TRATAMIENTO DE ACNÉ',
  items: [{
    name: 'Acné Therapy BY CINDY SALLOUM',
    price: '$160',
    description: 'Controla brotes, regula la grasa, calma la inflamación y mejora la textura.'
  }]
}, {
  category: 'FIRMEZA PREMIUM',
  items: [{
    name: 'Oxylift colágeno líquido',
    price: '$180',
    description: 'Mejora firmeza, elasticidad y aporta efecto lifting.'
  }]
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: [0.22, 1, 0.36, 1]
    }
  }
};
export function Services({
  setIsBookingOpen,
  onBookClick
}: ServicesProps) {
  const handleBook = () => {
    if (setIsBookingOpen) {
      setIsBookingOpen(true);
    } else if (onBookClick) {
      onBookClick();
    } else {
      window.open(CHECKOUT_URL, '_blank', 'noopener,noreferrer');
    }
  };
  return <section id="services" className="py-24 lg:py-32 bg-ivory" data-id="element-132">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-133">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="text-center mb-20 max-w-3xl mx-auto" data-id="element-134">
          <span className="text-gold text-sm font-medium tracking-[0.2em] uppercase mb-4 block font-sans" data-id="element-135">
            Nuestra Carta
          </span>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif text-softBlack mb-8" data-id="element-136">
            Nuestros Servicios
          </h2>
          <div className="bg-white p-8 rounded-2xl shadow-sm border border-gold/20 relative overflow-hidden" data-id="element-137">
            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-gold to-transparent opacity-50" data-id="element-138" />
            <p className="text-softBlack font-sans leading-relaxed text-lg" data-id="element-139">
              En <span className="font-semibold" data-id="element-140">BY CINDY SALLOUM</span>{' '}
              integramos la Terapia de Luz LED profesional Celluma en nuestros
              tratamientos para estimular la regeneración celular, disminuir la
              inflamación y potenciar los resultados.
            </p>
          </div>
        </motion.div>

        <div className="space-y-24" data-id="element-141">
          {serviceCategories.map((category, categoryIndex) => <motion.div key={categoryIndex} variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
          once: true,
          margin: '-50px'
        }} className="relative" data-id="element-142">
              <div className="flex items-center gap-6 mb-12" data-id="element-143">
                <h3 className="text-2xl md:text-3xl font-serif text-softBlack whitespace-nowrap" data-id="element-144">
                  {category.category}
                </h3>
                <div className="h-[1px] w-full bg-gold/30" data-id="element-145" />
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8" data-id="element-146">
                {category.items.map((service, serviceIndex) => <motion.div key={serviceIndex} variants={itemVariants} className="bg-white p-8 rounded-2xl shadow-sm hover:shadow-md transition-all duration-500 border border-transparent hover:border-gold/20 flex flex-col h-full group" data-id="element-147">
                    <div className="flex justify-between items-start mb-4 gap-4" data-id="element-148">
                      <h4 className="text-xl font-serif text-softBlack group-hover:text-gold transition-colors duration-300" data-id="element-149">
                        {service.name}
                      </h4>
                      <span className="text-lg font-serif text-gold whitespace-nowrap" data-id="element-150">
                        {service.price}
                      </span>
                    </div>
                    <p className="text-warmGray font-sans font-light leading-relaxed mb-8 flex-grow" data-id="element-151">
                      {service.description}
                    </p>
                    <button onClick={handleBook} className="text-sm font-medium text-gold hover:text-gold-dark transition-colors flex items-center gap-2 group-hover:gap-3 w-fit uppercase tracking-wider font-sans" data-id="element-152">
                      Agendar cita
                      <span className="text-lg transition-transform duration-300 group-hover:translate-x-1" data-id="element-153">
                        →
                      </span>
                    </button>
                  </motion.div>)}
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}